import { render, staticRenderFns } from "./MyApprovalList.vue?vue&type=template&id=867df128&lang=pug&"
import script from "./MyApprovalList.vue?vue&type=script&lang=js&"
export * from "./MyApprovalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports